export default __webpack_public_path__ + "static/media/easyOne.14087a37.png";